<h2 mat-dialog-title>
  {{'coverImages.edit_cover_image' | translate}}
</h2>

@if(saving)
  {
  <mat-spinner color="accent"></mat-spinner>
}
@else{
<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section">
      <p class="px-2" style="font-family: 'MyFont-Light';">
        {{'coverImageDescription1' | translate}}<br>
        {{'coverImageDescription2' | translate}}
      </p>
      <p class="px-2 mb-0" style="font-family: 'MyFont-Light'; font-size: 0.9rem;">
          {{'coverImages.update_visibility_delay' | translate}}
      </p>
      <div class="row pt-5">
        <!-- PHONE PREVIEW -->
        <div class="col-5 d-flex align-items-center justify-content-center" style="height: 60vh;">
          <div class="d-flex mobile-wrapper justify-content-center align-self-center">
            <section class="mobile">
              <div class="mobile-frame-container"></div>
              <div class="mobile-frame">
                <div class="d-flex flex-column-reverse pb-1 h-100">
                  <div class="mx-1">
                    <span class="material-symbols-outlined close-icon">
                      close
                    </span>

                    <img
                                                [src]="previewSrc 
                                                        || coverImage?.imageUrl 
                                                        || './../../assets/img/appstore-narravero_EN-app-clip_v2.jpg'"
                      class="w-100"
                      onerror="this.src='./../../assets/img/default.jpg'"
                      style="border-top-left-radius: 25px; border-top-right-radius: 25px;"
                      />

                    <div
                                                style="background-color:#E6E6E3;font-size:12px;line-height: 13px;
                                                    border-bottom-left-radius: 25px; border-bottom-right-radius: 25px;"
                      class="p-3"
                      >
                      <div class="d-flex justify-content-between">
                        <div style="overflow-wrap:anywhere;">
                          <h4 class="mb-1"><strong>{{ previewTitle }}</strong></h4>
                          <div class="subtitle-truncate">
                            <strong>{{ previewSubtitle }}</strong>
                          </div>
                        </div>

                        <div class="align-self-center">
                          <button mat-button class="default-blue-button px-1">
                            {{'open' | translate}}
                          </button>
                        </div>
                      </div>

                      <mat-divider class="py-2 mt-3"></mat-divider>

                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center justify-content-start">
                          <div class="fake-icon"></div>
                          <div>
                            <span style="font-size:10px;">Bereitgestellt von</span><br />
                            <strong style="font-size:11px;">Narravero Reader</strong>
                          </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-end">
                          <div class="fake-icon-small"></div>
                          <div style="font-size:10px;">App Store</div>
                          <span class="material-symbols-outlined"
                            style="font-size: 13px; vertical-align: middle;">
                            chevron_right
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <!-- SETTINGS PART -->
        <div class="col-7">
          <mat-card>
            <form [formGroup]="advancedForm">
              <mat-tab-group mat-stretch-tabs class="w-100" animationDuration="300ms">
                <mat-tab label="Image">
                  <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined">image</mat-icon>
                    <span class="ms-2">{{'pass.widgets.types.image' | translate}}</span>
                  </ng-template>


                  <div class="px-2 py-3">
                    @if (coverImage) {
                      <div class="mt-2">
                        <div class="d-flex justify-content-stretch">
                          @if (coverImage) {
                            <div class="custom-form-field w-100">
                              <div appDragAndDrop (files)="filesDropped($event)">
                                <mat-card class="upload-section text-center justify-content-center">
                                  <div style="margin:0 auto; height:100%;" class="d-flex justify-content-end flex-column">
                                    <div class="p-2 my-4 text-center">
                                      <img
                                        [src]="previewSrc || coverImage?.imageUrl || './../../assets/img/default.jpg'"
                                        class="w-100"
                                        onerror="this.src='./../../assets/img/default.jpg'"
                                        style="object-fit: cover; border-radius:10px; width:100%;"
                                        />
                                      <button mat-button class="my-3 orange-button" for="imageFile" (click)="myfile.click()">
                                        {{'replace_img' | translate}}
                                      </button>
                                      <!-- accept={{data.supportedFileAccept}}  -->
                                      <input  type="file"
                                        #myfile
                                        id="myfile"
                                        name="myfile"
                                        style="display:none"
                                        accept=".jpg,.jpeg,.png"
                                        (change)="onFileChange($event)"
                                        >
                                      </div>
                                      <p class="py-2 mt-2"><p> {{'coverImages.image_size' | translate}}</p>
                                    </div>
                                  </mat-card>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (!coverImage) {
                        <div>
                          <div appDragAndDrop (files)="filesDropped($event)">
                            <mat-card class="upload-section text-center justify-content-center" style="min-height: 350px;">
                              <div style="margin:0 auto; height:100%;" class="d-flex justify-content-end flex-column">
                                <div class="p-2 mb-4 text-center">
                                  @if (previewSrc) {
                                    <img
                                      [src]="previewSrc"
                                      class="w-100"
                                      onerror="this.src='./../../assets/img/default.jpg'"
                                      style="object-fit: cover; border-radius:10px; width:100%;"
                                      />
                                  }
                                  @if (previewSrc) {
                                    <button  mat-button class="my-3 orange-button" for="imageFile" (click)="myfile.click()">
                                      {{'replace_img' | translate}}
                                    </button>
                                  }
                                  @if (!previewSrc) {
                                    <mat-icon class="decoration-icon material-symbols-outlined">add_photo_alternate</mat-icon>
                                  }
                                  @if (!previewSrc) {
                                    <button  mat-button class="my-3 orange-button" for="imageFile" (click)="myfile.click()">
                                      {{'pass.browse' | translate}}
                                    </button>
                                  }
                                  <!-- accept={{data.supportedFileAccept}}  -->
                                  <input
                                    type="file"
                                    #myfile
                                    id="myfile"
                                    name="myfile"
                                    style="display: none;"
                                    accept=".jpg, .jpeg, .png"
                                    (change)="onFileChange($event)"
                                    >
                                </div>
                                <p class="py-2 mt-2"><p> {{'coverImages.image_size' | translate}}</p>
                              </div>
                            </mat-card>
                          </div>
                        </div>
                      }

                    </div>

                  </mat-tab>
                  <mat-tab label="Settings">
                    <ng-template mat-tab-label>
                      <mat-icon class="material-symbols-outlined">article</mat-icon>
                      <span class="ms-2">{{'contentTypes.text' | translate}}</span>
                    </ng-template>

                    <div class="p-4">

                      <mat-form-field appearance="outline" class="w-100 mb-1">
                        <!-- <mat-label>{{'language' | translate}}</mat-label> -->
                        <mat-label>{{'defaultLanguage' | translate}}</mat-label>
                        <mat-select formControlName="defaultLanguage" class="input-group" required>
                          @for (lang of languagesList | keyvalue; track lang) {
                            <mat-option [value]="lang.key" data-nar="dpp-language-dropdown-option">
                              {{lang.value}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (!advancedForm.hasError('language')) {
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 mb-1">
                        <mat-label>{{'coverImages.ci_title' | translate}}</mat-label>
                        <!-- needs to show existing value if existing-->
                        <input formControlName="title" type="text" matInput placeholder="Narravero" required maxlength="30">
                        <mat-hint align="end">{{advancedForm.get('title').value?.length || 0}}/30</mat-hint>
                        @if ( !advancedForm.hasError('title')) {
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 mb-1">
                        <mat-label>{{'coverImages.ci_subtitle' | translate}}</mat-label>
                        <!-- needs to show existing value if existing-->
                        <input formControlName="subtitle" type="text" matInput placeholder="Touchpoint" required maxlength="56">
                        <mat-hint align="end">{{advancedForm.get('subtitle').value?.length || 0}}/56</mat-hint>
                        @if ( !advancedForm.hasError('subtitle')) {
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <mat-accordion>
                      <mat-expansion-panel expanded>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <span class="fs-6">{{'content.translations' | translate}}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        @if (advancedForm) {
                          <ng-container formArrayName="translations">
                            @for (group of translations.controls; track group; let i = $index) {
                              <div class="my-3 p-2 border rounded"
                                [formGroupName]="i">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                  <div class="badge text-dark px-2 py-1">
                                    {{ languagesList[group.get('lang')?.value] }}
                                  </div>
                                  <button mat-icon-button class="delete-button material-symbols-outlined" (click)="removeTranslation(i)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                                <input type="hidden" formControlName="lang" />
                                <div class="d-flex gap-2 align-items-start">
                                  <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'coverImages.ci_title' | translate }}</mat-label>
                                    <input matInput formControlName="title" required maxlength="30">
                                    <mat-hint align="end">
                                      {{ group.get('title')?.value?.length || 0 }}/30
                                    </mat-hint>
                                    @if (group.get('title')?.invalid && group.get('title')?.touched) {
                                      <mat-error>
                                        {{'required' | translate}}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                  <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'coverImages.ci_subtitle' | translate }}</mat-label>
                                    <input matInput formControlName="subtitle" required maxlength="56"/>
                                    <mat-hint align="end">
                                      {{ group.get('subtitle')?.value?.length || 0 }}/56
                                    </mat-hint>
                                    @if (group.get('subtitle')?.invalid && group.get('subtitle')?.touched) {
                                      <mat-error>
                                        {{'required' | translate}}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </div>
                            }
                          </ng-container>
                        }

                        <button
                          class="secondary-gray-button my-2"
                          mat-button
                          type="button"
                          [matMenuTriggerFor]="menu">
                          <mat-icon>add</mat-icon> {{ 'add' | translate }}
                        </button>

                        <mat-menu #menu="matMenu" [overlapTrigger]="false">
                          @for (lang of remainingLanguagesList; track lang) {
                            <button
                              mat-menu-item
                              type="button"
                              (click)="addTranslation(lang.key)">
                              {{ lang.label }}
                            </button>
                          }
                          @if (remainingLanguagesList.length === 0) {
                            <button mat-menu-item type="button" disabled>
                              All languages added
                            </button>
                          }
                        </mat-menu>


                      </mat-expansion-panel>
                    </mat-accordion>
                  </mat-tab>
                </mat-tab-group>

              </form>
            </mat-card>
          </div>
        </div>
      </section>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();"> {{'cancel' | translate}} </button>
    <button mat-button class="orange-button" [disabled]="saving || advancedForm.invalid || !isUrlPrefixValid || (alreadyPrefix && !isUpdate)"  (click)="dialogSave();"> {{ 'save' | translate }}</button>
  </mat-dialog-actions>

}
